import React, { createRef, useState } from 'react';
import classNames from 'classnames';
import UploadProgress from './UploadProgress';
import checkIcon from '../../../assets/images/check.svg';
import CircularProgress from '@material-ui/core/CircularProgress';

function FileUploadButton({
  children,
  disabled,
  image,
  className,
  onFileSelected,
  accept = '*'
}) {
  const fileInputRef = createRef();
  const [state, setState] = useState({
    isUploading: false,
    isCompleted: false,
    progress: 0
  });

  const openFileDialog = () => {
    if (!state.isUploading && !state.isCompleted) {
      fileInputRef.current.click();
    }
  };

  const handleFileSelection = e => {
    const files = e.target.files;

    if (files[0] && typeof onFileSelected === 'function') {
      onFileSelected(files[0], {
        setStarted,
        setProgress,
        setCompleted,
        resetState
      });
    }
  };

  const setProgress = value => {
    setState({
      ...state,
      isUploading: true,
      progress: value
    });
  };

  const resetState = () => {
    setState({
      isUploading: false,
      isCompleted: false,
      progress: 0
    });
  };

  const setStarted = () => {
    setState({
      ...state,
      progress: 0,
      isUploading: true
    });
  };

  const setCompleted = () => {
    setState({
      ...state,
      progress: 100,
      isUploading: false,
      isCompleted: true
    });
  };

  const completedIcon = (
    <div className="checkmark-icon">
      <img src={checkIcon} alt="" width="40" height="40" />
    </div>
  );

  return (
    <div
      className={classNames({
        [className]: !!className,
        'file-upload-button': true,
        uploading: state.isUploading,
        'upload-success': state.isCompleted
      })}
      onClick={openFileDialog}
    >
      {state.isCompleted ? completedIcon : null}
      {image && !state.isUploading ? (
        <div className="image">{image}</div>
      ) : null}
      {!state.isUploading ? <div className="label">{children}</div> : null}
      {state.isUploading ? <CircularProgress /> : null}

      <input
        ref={fileInputRef}
        className="file-input"
        type="file"
        disabled={disabled}
        accept={accept}
        onChange={handleFileSelection}
      />
    </div>
  );
}

export default FileUploadButton;
